import { c as _c } from "react/compiler-runtime";
import { CheckCircleIcon } from '@systemeio/ui/icons';
import { PrimaryButton } from '@systemeio/ui';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { CourseThemeColorSetInterface } from '../types/course-theme-color-set-interface';
import CourseThemePreview from './course-theme-preview';
interface CourseThemeSelectItemProps {
  theme: CourseThemeColorSetInterface;
  selected: boolean;
  id: number;
  onChange: (id: number) => void;
}
const CourseThemeSelectItem = t0 => {
  const $ = _c(23);
  const {
    theme,
    selected,
    onChange,
    id
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== id || $[1] !== onChange || $[2] !== selected) {
    t1 = selected ? undefined : () => onChange(id);
    $[0] = id;
    $[1] = onChange;
    $[2] = selected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = selected ? "border-green border-2" : "cursor-pointer";
  let t3;
  if ($[4] !== t2) {
    t3 = twMerge("group relative min-h-[190px] overflow-hidden rounded-xl", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== id || $[7] !== theme) {
    t4 = <CourseThemePreview theme={theme} themeId={id} />;
    $[6] = id;
    $[7] = theme;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = selected ? "flex" : "hidden group-hover:flex";
  let t6;
  if ($[9] !== t5) {
    t6 = twMerge("bg-background-secondary/50 absolute top-0 h-full w-full items-center justify-center", t5);
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== selected || $[12] !== t) {
    t7 = selected ? <span className="text-green flex gap-2 font-bold"><CheckCircleIcon className="fill-green" />{t("dashboard.course.theme_selected")}</span> : <PrimaryButton className="bg-green hover:bg-green">{t("dashboard.course.select_theme")}</PrimaryButton>;
    $[11] = selected;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== selected || $[18] !== t1 || $[19] !== t3 || $[20] !== t4 || $[21] !== t8) {
    t9 = <div role="radio" aria-checked={selected} onClick={t1} className={t3}>{t4}{t8}</div>;
    $[17] = selected;
    $[18] = t1;
    $[19] = t3;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default CourseThemeSelectItem;